import Immutable from 'immutable';

const LOAD = 'tenant/LOAD';
const LOAD_SUCCESS = 'tenant/LOAD_SUCCESS';
const LOAD_FAIL = 'tenant/LOAD_FAIL';
const LOAD_ADD_SUCCESS = 'tenant/LOAD_ADD_SUCCESS';
const LOAD_ALL_SUCCESS = 'tenant/LOAD_ALL_SUCCESS';
const LOAD_TENANT_SUCCESS = 'tenant/LOAD_TENANT_SUCCESS';
const CREATE_NEW = 'tenant/CREATE_NEW';

const LOAD_TENANT_INFO_SUCCESS = 'tenant/LOAD_TENANT_INFO_SUCCESS';
const LOAD_TENANT_INFO_FAIL = 'tenant/LOAD_TENANT_INFO_FAIL';

const initialState = Immutable.fromJS({
  Tenants: null,
  loading: false,
  errorMessage: null,
  activePage: 1,
  AllTenants: null,
  tenant: null,
  tenantInfo: null,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('loading', true);

    case LOAD_FAIL:
      return state
        .set('loading', false)
        .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
      return state
        .set('loading', false)
        .set('activePage', action.page)
        .set('Tenants', action.Tenants);

    case LOAD_ALL_SUCCESS:
      return state
        .set('loading', false)
        .set('AllTenants', action.Tenants);

    case LOAD_ADD_SUCCESS:
      return state
        .set('loading', false)
        .set('Tenant', action.result);

    case LOAD_TENANT_SUCCESS:
      return state
        .set('tenant', action.result);
    
    case LOAD_TENANT_INFO_SUCCESS:
      return state
        .set('tenantInfo', action.result);

    case LOAD_TENANT_INFO_FAIL:
      return state
        .set('errorMessage', action.result);

    case CREATE_NEW:
      return state
        .set('tenant', action.result);

    default:
    return state;
  }
}

export const getTenant = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/tenant');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, Tenants: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getAllTenant = (offset, page) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get(`/tenant/tenantAll/`);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_ALL_SUCCESS, Tenants: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const creatNew = () => async(dispatch) => {
  dispatch({ type: CREATE_NEW, result: { active: 1 } })
}

export const addTenant = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/tenant', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const updateTenant = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/tenant', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const deleteTenant = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.del('/tenant', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const tenants = getState().get('tenant').get('Tenants');
    const list = tenants.filter((tenant) =>  tenant.id !== data.id);

    dispatch({ type: LOAD_SUCCESS, Tenants: list });
    return list;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const getTenantById = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/tenant/tenantGetById/' + id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_TENANT_SUCCESS, result: Object.assign({}, res, { active: res.active === '1' }) });
    return res;

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getTenantByFarmId = (id) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/tenant/tenantGetByFarmId/' + id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, result: res });
    return res;

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};



export const updateTenantById = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/tenant/updateTenantById', { data });
    if(res.status){
      return res.data
    }else{
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
    }
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const unlinkTenantToFarm = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.del('/tenant/unlink_tenant_to_farm', { data });
    if(res.status){
      return true
    }else{
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return false
    }
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
    return false
  }
};


/**
 * Tenant info report functionality
 */

export const tenantInfoReport = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });

  try {
    const res = await api.get('/tenant/tenants-info-reports');
    if (res.message) {
      dispatch({ type: LOAD_TENANT_INFO_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_TENANT_INFO_SUCCESS, result: res });
    return res;

  } catch (error) {
    dispatch({ type: LOAD_TENANT_INFO_FAIL, errorMessage: error });
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/tenant.js